/**
 * SB6-ANA-CACHE-03 — React read surface over the user-configurable cache budget.
 */
import { useSyncExternalStore } from "react";
import { storageBudget, type StorageBudget } from "./storageBudget.js";

export function useStorageBudget(): StorageBudget {
  return useSyncExternalStore(
    storageBudget.subscribe,
    storageBudget.getBudget,
    storageBudget.getBudget,
  );
}
